import { Flex, FloraTag, FloraTypography } from '@grupoboticario/flora-react'

import { formatCurrency } from '@/utils/format/formatCurrency'

import * as S from './TagBox.styles'

const themeStyles = {
  dark: {
    color: '$statusSuccessNonInteractiveAltPredominant',
    backgroundColor: '$statusSuccessNonInteractivePredominant'
  },
  light: {
    color: '$statusSuccessNonInteractivePredominant',
    backgroundColor: '$background'
  }
}

const TagBox = ({ title, points, value, theme, textTransform = 'capitalize' }) => (
  <Flex css={S.containerCss} direction="column" gap="$2">
    <FloraTag
      css={S.tagCss(themeStyles[theme].color, themeStyles[theme].backgroundColor, textTransform)}
      type="readOnly"
      size="medium"
    >
      {title}
    </FloraTag>
    <FloraTypography css={S.emphasisTextCss} fontSize="bodySmallStandard">
      {points.toLocaleString('pt-BR')} pontos
    </FloraTypography>
    <FloraTypography css={S.valueCss} fontSize="bodySmallStandard" fontWeight="bold">
      {formatCurrency(value ?? 0)}
    </FloraTypography>
  </Flex>
)

export default TagBox
